// extracted by mini-css-extract-plugin
export default {"title":"q6aShi"};